import * as yup from "yup"
import type { NamedEntity } from "../../types"

export function initialValuesNamedEntity(namedEntity?: NamedEntity | undefined, type?: string) {
  if (namedEntity) {
    return namedEntity
  }
  return {
    name: "",
    entity_type: type || "",
    description: "",
    date: "",
    place: "",
  }
}

export function validationSchemaNamedEntity() {
  return yup.object().shape({
    name: yup.string().required("Campo obbligatorio"),
    entity_type: yup.string().required("Campo obbligatorio"),
  })
}
